module.exports = __webpack_public_path__ + "img/register-phone.f2b98e01.png";